/* MitoGenix add-to-cart confirmation + cart refresh helpers */
(function () {
  var CART_URL = (window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartUrl) || '/cart';
  // Re-sync cart count + the sliding cart window after an add that bypassed the theme's own form handler.
  window.mgCartRefresh = function () {
    fetch(CART_URL + '.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
    }).catch(function () {});
    // No `cart` in detail on purpose (see ApProductForm); never auto-open the drawer on add.
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { openMiniCart: false } }));
  };
  function flash(btn) {
    btn.classList.add('mg-added');
    clearTimeout(btn._mgAddedTimer);
    btn._mgAddedTimer = setTimeout(function () { btn.classList.remove('mg-added'); }, 1800);
  }
  // Theme product forms (cards, quick-add) dispatch variant:added on success.
  document.addEventListener('variant:added', function (e) {
    var form = e.target;
    if (!form || !form.querySelectorAll) return;
    form.querySelectorAll('button[type="submit"]').forEach(flash);
  });
})();

/* Mobile account icon: tap opens the dropdown and waits for a selection instead of navigating.
   Tap the icon again or anywhere else to close. Desktop (hover) is untouched. */
(function () {
  if (window.__mgUserTap) return;
  window.__mgUserTap = true;
  var mq = window.matchMedia('(max-width: 767px)');
  document.addEventListener('click', function (e) {
    var open = document.querySelector('.header-user.mg-user-open');
    var link = e.target.closest && e.target.closest('.header-user .login-icon__link');
    if (link && mq.matches) {
      e.preventDefault();
      var box = link.closest('.header-user');
      if (open && open !== box) open.classList.remove('mg-user-open');
      box.classList.toggle('mg-user-open');
      return;
    }
    if (open && !(e.target.closest && e.target.closest('.header-user .user-block'))) {
      open.classList.remove('mg-user-open');
    }
  });
})();
